import * as React from 'react';
import { SpeedDial, SpeedDialIcon, SpeedDialAction } from '@mui/material';
import ExtensionIcon from '@mui/icons-material/Extension';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import { PinDrop } from '@material-ui/icons';

const actions = [
  { icon: <ExtensionIcon />, name: 'Polygon' },
  { icon: <HorizontalRuleIcon />, name: 'Line' },
  { icon: <PinDrop />, name: 'Pin' },
];

export default function FabSpeedDial({ handleMode }) {
  return (
    <SpeedDial ariaLabel="SpeedDial example" sx={{ position: 'absolute', bottom: 8, right: 8 }} icon={<SpeedDialIcon />}>
      {actions.map(action => (
        <SpeedDialAction
          key={action.name}
          icon={action.icon}
          tooltipTitle={action.name}
          onClick={() => handleMode(action.name)}
        />
      ))}
    </SpeedDial>
  );
}
